//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"Commission",1,0],[0,"ControlVoltage",1,0],[0,"Customer",1,0],[0,"Description",1,0],[0,"Id",1,0],[0,"Location",1,0],[0,"ManufacturingYear",1,0],[0,"Name",1,0],[0,"PowerInput",1,0],[0,"ProjectTargetPath",1,0],[0,"ProjectTemplateFile",1,0]],[[["nDetails"],"GetDetails",{R_:{details:""}},0,0],[["details"],"SetDetails",{},1,0],[[],"ResetProjectTemplate",{},0,0]],[]];
SPLM.AME.EplanSettingsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.EplanSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;